export const dev = {
  orchestratorServer: {
    baseUri: 'http://localhost:4000',
  },
};
